import { gql } from '@web/federation/gql'

export const UpcomingBookingQuery = gql(`
  query UpcomingBookingQuery($page:Int, $limit:Int) {
    me {
      ...on MeSucceed {
        ...UpcomingSection_UpcomingBookings
      }
    }
  }

  fragment UpcomingSection_UpcomingBookings on MeSucceed {
    upcomingBookings( page:$page, limit: $limit) {
      bookings {
        ... on Booking {
          ...UpcomingSection_UpcomingBooking
        }
      }
      pageInfo {
        page
        nextPage
        totalCount
        hasNextPage
      }
    }
  }

  fragment UpcomingSection_UpcomingBooking on Booking {
      id
      bizItemThumbImage
      formattedBookingDateText
      bizItemName
      businessName
      businessId
      label
      price
      bookingStatusCode
      landingUrl
      displayOrderTimestamp
      remainDays
      directionLandingUrl(appName: "m.place.naver.com/my") {
        car {
          appScheme
          webUrl
        }
      }
      placeSummary {
        id
        name
        directionLandingUrl(appName: "m.place.naver.com/my") {
          car {
            appScheme
            webUrl
          }
        }
        coordinate {
          longitude
          latitude
        }
      }
  }
`)
